import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import { SearchIcon } from '@components/atoms';
const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    border: '1px solid #d0d5dd',
    backgroundColor:"#ffffff",
    borderRadius: "8px",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        fontSize: "16px",
        fontWeight: "normal",
        lineHeight:"1.5",
        color:"#667085",
        fontFamily:"Inter"
    },
}));

export const CustomSearch = () => {
    return (
        <Box sx={{ flexGrow: 1 }}>

            <Search>
                <SearchIconWrapper>
                    <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                    placeholder="Search…"
                    inputProps={{ 'aria-label': 'search' }}
                />
            </Search>

        </Box>
    );
}
